import { lazy } from "react"

// Per-customer export forms, loaded on first render instead of with whatever imports the
// customer config (the entry chunk). Only dynamic imports here — a static import of any form
// would pull all of them back in. Render sites wrap these in a local <Suspense>.
export const LazyEssexConfirmExportComponent = lazy(() => import("./Essex").then((m) => ({ default: m.EssexConfirmExportComponent })))
export const LazySurreyConfirmExportComponent = lazy(() => import("./Surrey").then((m) => ({ default: m.SurreyConfirmExportComponent })))
export const LazyMedwayConfirmExportComponent = lazy(() => import("./Medway").then((m) => ({ default: m.MedwayConfirmExportComponent })))
export const LazyJerseyHighWorkxExportComponent = lazy(() =>
    import("./Jersey").then((m) => ({ default: m.JerseyHighWorkxExportComponent })),
)
export const LazyLancashireConfirmExportComponent = lazy(() =>
    import("./Lancashire/confirm").then((m) => ({ default: m.LancashireConfirmExportComponent })),
)
export const LazyNorthamptonConfirmExportComponent = lazy(() =>
    import("./Northampton").then((m) => ({ default: m.NorthamptonConfirmExportComponent })),
)
export const LazyGloucestershireConfirmExportComponent = lazy(() =>
    import("./Gloucestershire").then((m) => ({ default: m.GloucestershireConfirmExportComponent })),
)
export const LazyHertfordshireConfirmExportComponent = lazy(() =>
    import("./Hertfordshire").then((m) => ({ default: m.HertfordshireConfirmExportComponent })),
)
export const LazyPeterboroughConfirmExportComponent = lazy(() =>
    import("./Peterborough").then((m) => ({ default: m.PeterboroughConfirmExportComponent })),
)
export const LazyWestBerkshireConfirmExportComponent = lazy(() =>
    import("./WestBerkshire").then((m) => ({ default: m.WestBerkshireConfirmExportComponent })),
)
export const LazyWestSussexConfirmExportComponent = lazy(() =>
    import("./WestSussex").then((m) => ({ default: m.WestSussexConfirmExportComponent })),
)
export const LazyBuckinghamshireCausewayExportComponent = lazy(() =>
    import("./Buckinghamshire").then((m) => ({ default: m.BuckinghamshireCausewayExportComponent })),
)
export const LazyNorthumberlandCausewayExportComponent = lazy(() =>
    import("./Northumberland").then((m) => ({ default: m.NorthumberlandCausewayExportComponent })),
)
export const LazyCambridgeshireAuroraExportComponent = lazy(() =>
    import("./Cambridgeshire").then((m) => ({ default: m.CambridgeshireAuroraExportComponent })),
)
